import { onMounted, onUnmounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import {
  registerPushServiceWorker,
  syncWebPushSubscription,
} from '@/backend/webPushClient'
import { isImpersonationTab } from '@/backend/auth/tokenStorage.mjs'
import { useNotificationUser } from '@/composables/useNotificationUser'

/**
 * Регистрирует SW и синхронизирует Web Push-подписку после логина.
 * Клик по OS-уведомлению (postMessage, если navigate недоступен) ведёт в SPA.
 */
export function useWebPush() {
  const router = useRouter()
  const { isAuthenticated } = useNotificationUser()

  function onSwMessage(event) {
    const data = event.data
    if (!data || data.type !== 'erp-push-navigate' || !data.url) return
    router.push(data.url).catch(() => {})
  }

  async function sync(requestPermission) {
    if (!isAuthenticated.value || isImpersonationTab()) return
    await registerPushServiceWorker()
    await syncWebPushSubscription({ requestPermission })
  }

  watch(isAuthenticated, (ok) => {
    if (ok) sync(false)
  })

  onMounted(() => {
    if (navigator.serviceWorker?.addEventListener) {
      navigator.serviceWorker.addEventListener('message', onSwMessage)
    }
    if (isAuthenticated.value) sync(false)
  })

  onUnmounted(() => {
    if (navigator.serviceWorker?.removeEventListener) {
      navigator.serviceWorker.removeEventListener('message', onSwMessage)
    }
  })

  return { ensurePush: () => sync(true) }
}
